declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel(pixelId: string) {
  if (typeof window === 'undefined') return
  if (window.fbq) return // already initialized

  const fbq = function (...args: unknown[]) {
    if ((fbq as any).callMethod) {
      ;(fbq as any).callMethod.apply(fbq, args)
    } else {
      ;(fbq as any).queue.push(args)
    }
  } as any

  if (!window._fbq) window._fbq = fbq
  window.fbq = fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  window.fbq('init', pixelId)
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
